<template>
    <div v-if="conf" class="tpl-ticket" :style="{ backgroundColor: conf.background_color }">
        <TransparentHeader :scrollHeight="100" :color="conf.background_color" titleColor="#FFFFFF" :titleCustomOpacity="1">
        </TransparentHeader>
        <div>
            <img class="top-img" v-if="conf.top_img" :src="conf.top_img" alt="">
            <div class="ticket-info" :style="{ backgroundImage: `url(${conf.coupon_img})` }" @click="couponClick">
                <div class="range-coupon">

                    <div class="text"> {{received?'立即使用':'立即领取'}}</div>
                </div>

                <div class="button-phone">
                    <img class="button-img" v-if="conf.button_img && conf.org_id" :src="conf.button_img" alt="" @click.stop="jumpMiniProgram">
                    <div class="change-phone" @click.stop="changeMobileClick">
                        更换手机号领取
                    </div>
                </div>
            </div>
            <div class="explain-info" v-if="conf.remark" v-html="conf.remark">
            </div>
        </div>

        <van-dialog v-model="changeMobileModelShow" title="" :showConfirmButton="false">
            <div class="dialog-wrap">
                <li class="title">更换手机号领取</li>
                <div>
                    <li class="label">领取手机号</li>
                    <input class="input" type="number" v-model="phone">
                </div>
                <div class="btn" @click="confirmReceive">
                    确认领取
                </div>
            </div>
            <img class="dialog-close" @click="changeMobileModelShow=false"
                 src="../../../assets/img/202305/tpl-ticket/close.png" alt="">
        </van-dialog>

    </div>
    <div v-else class="loading-wrap">
        <van-loading>加载中...</van-loading>
    </div>
</template>

<script>

    import {Dialog, Loading} from 'vant';
    import {receiveCarCouponConf, receiveCarCoupon} from '../../../api/202305/tpl-ticket'
    import {goodsJump, getPlatform} from '@/common/utils'
    const {isIPhoneX, currentPlatform} = getPlatform();
    import TransparentHeader from '@/common/components/TransparentHeader'
    export default {
        name: "tplTicket",
        components: {
            TransparentHeader,
            [Dialog.Component.name]: Dialog.Component,
            [Loading.name]: Loading,
        },
        data() {
            return {
                id: '',
                conf: '',
                received: false,
                isCouponLoading:false,
                phone:'',
                changeMobileModelShow: false,
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getReceiveCarCouponConf()
        },
        methods: {
            getReceiveCarCouponConf() {
                receiveCarCouponConf({id: this.id}).then((res) => {
                    let resData = res.data.data
                    this.conf = resData.conf
                    this.received = resData.received
                    document.title=resData?.conf?.title || ''
                    if(!resData.received){
                        this.getTongchengSendCoupon()
                    }
                })
            },
            //埋点
            trackEvent(key = "领券活动模板") {
                this.$uweb.trackEvent("tplTicket", key+'id:'+this.id, currentPlatform);
            },
            //点击更换手机号
            changeMobileClick() {
                this.trackEvent('更换手机按钮点击量');
                this.changeMobileModelShow = true
            },
            //type auto  passivity:会弹出toast
            getTongchengSendCoupon(type = 'auto') {
                if (this.isCouponLoading) {
                    return
                }
                this.isCouponLoading = true
                let params={
                    id:this.id
                }
                if(this.phone){
                    params.phone=this.phone
                }
                receiveCarCoupon(params).then((res) => {
                    let resData = res.data
                    console.log(res,'resresresres')
                    this.received = true
                    if (type == 'passivity') {
                        if (resData.code == 200) {
                            this.$toast('领取成功')
                        } else {
                            //一般情况下不会走到这里
                            this.$toast(resData?.message || '您的手机号暂不能领取，请更换手机号领取')
                        }
                    }
                }).catch(() => {
                    this.received =false
                }).finally(() => {
                    this.isCouponLoading = false
                })
            },
            //优惠券领取
            couponClick() {
                this.trackEvent('优惠券按钮点击量');
                if (this.received) {
                    //成功领取则跳转小程序
                    this.jumpMiniProgram()
                } else {
                    //发起领取请求
                    this.getTongchengSendCoupon('passivity')
                }
            },
            //确认领取按钮
            confirmReceive() {
                if (!/^\d{11}$/.test(this.phone)) {
                    this.$toast('请输入正确手机号')
                    return
                }
                this.changeMobileModelShow = false
                this.getTongchengSendCoupon('passivity')
            },
            jumpMiniProgram(){
                this.trackEvent('跳转按钮点击量');
                if (this.$GY_platform.isGYApp) {
                    let isH5Url=/^http(s):\/\//.test(this.conf?.url)
                    let isAppUrl=/^code-/.test(this.conf?.url)
                    if(isH5Url){
                        window.location.href = this.conf?.url
                    }else if(isAppUrl){
                        let opt = {
                            type: 23,
                            appurl: this.conf.url
                        }
                        goodsJump(opt)
                    }else if(this.conf?.org_id){
                        // let opt = {
                        //     type: 52,
                        //     orgId: this.conf.org_id
                        // }
                        // if(this.conf.url){
                        //     opt.type=35
                        //     opt.appurl= this.conf.url
                        // }
                        // goodsJump(opt)
                            let opt = {
                                type: 35,
                                appurl: this.conf.url,
                                orgId: this.conf.org_id
                            }
                            goodsJump(opt)
                    }

                } else {
                    this.$toast('请下载高佣APP')
                }
            }
        }
    }
</script>

<style lang="less" scoped>

    .loading-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
    }
    .tpl-ticket {
        min-height: 100vh;
        padding-bottom: 24px;
        li {
            list-style: none;
        }
        .top-img {
            width: 100%;
        }
        .ticket-info {
            width: 686px;
            height: 453px;
            background-size: 100%;
            margin: 0 auto;
            position: relative;
            .range-coupon {
                width: 638px;
                height: 138px;
                position: relative;
                top: 100px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .text {
                    font-size: 28px;
                    font-weight: 700;
                    color: #FEE76B;
                    margin-right: 26px;
                }
            }

            .button-phone {
                position: relative;
                top: 140px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .button-img {
                    width: 646px;
                }
                .change-phone {
                    font-size: 28px;
                    font-weight: 500;
                    color: #FE4617;
                    margin-top: 32px;
                }
            }

        }
        .explain-info {
            width: 686px;
            background: rgba(0,0,0,0.1);
            border-radius: 20px;
            margin:24px auto 0;
            padding: 32px;
        }
    }
    .dialog-wrap {
        width: 580px;
        background: #fff;
        border-radius: 40px;
        padding: 40px 40px 56px;

        .title {
            font-size: 34px;
            font-weight: 700;
            color: #1A1A1A;
            text-align: center;
        }

        .label {
            font-size: 24px;
            font-weight: 400;
            color: #808080;
            margin-top: 64px;
        }

        .input {
            width: 500px;
            height: 84px;
            background: #F5F5F5;
            border-radius: 20px;
            font-size: 32px;
            font-weight: 600;
            color: #1A1A1A;
            margin-top: 24px;
            padding: 30px;
        }

        .btn {
            width: 340px;
            height: 76px;
            border-radius: 38px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 56px auto 0;
            font-weight: 700;
            background: linear-gradient(90deg, #FF4600, #FFBA00);
        }
    }

    .dialog-close {
        width: 54px;
        position: relative;
        left: 50%;
        margin-top: 100px;
        transform: translate(-50%);
    }

    /deep/ .van-dialog {
        background: transparent;
        width: auto
    }


</style>
